// extracted by mini-css-extract-plugin
module.exports = {"comp":"CardD_comp__xtNpM"};